export const fectServiceApi = async (url,params={}) => {
  return await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
  }).then((response) => response.json());
};

// Send GROC query of sanity
export const fetchSanityData = async (url,params={}) => {
  let encodeParams = encodeURI(btoa(JSON.stringify(params)));
  return await fetch(url+'?params='+encodeParams, {
    method: 'GET',
    cache: "no-store"
  }).then((response) => response.json());
};

export const postSanityData = async (url,params={}) => {
  return await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
  }).then((response) => response.json());
};

/*
  GET query
*/
export const getSanityData = async (url,params='') => {
  return await fetch(url+'/?'+params, {
    method: 'GET',
  }).then((response) => response.json());
};